
// based on config returns the getters
import getProp from 'lodash.get'
import { setFieldValues } from './utils'

export default ({ config, common }) => {
  return {
    // getters for internal use start with _
    _paginationObject (state) {
      // create GRPC-object based on state.pagination
      if (config.service.features.pagination) {
        let po = setFieldValues(config, null, config.service.paginationObjectType, state.pagination)
        return po
      } else {
        return null
      }
    },
    _sortingObject (state) {
      // create GRPC-object based on state.sort
      if (config.service.features.sorting) {
        let soArray = []
        state.sort.forEach(s => {
          let mo = setFieldValues(config, null, config.service.sortObjectType, s)
          soArray.push(mo)
        })
        return soArray
      } else {
        return null
      }
    },
    // return Work-In-Progress of active item (the editing state)
    // if we have unsaved changes to active item
    // else return false
    activeItemEdited (state) {
      if (state.activeItem) {
        let item = state.editingItems.find(editedItem => getProp(editedItem.item, config.items.keyField, null) === getProp(state.activeItem, config.items.keyField, null))
        return item ? item.item : false
      }
      return false
    },
    activeItemKey (state) {
      return getProp(state.activeItem, config.items.keyField, null)
    },
    canLoadNextPage (state, getters) {
      // TODO: refactor at some point to not rely on afterKey always but based on config
      return getters.filteredCount > 0 && state.items.length < getters.filteredCount && state.pagination.afterKeyList.length > 0
    },
    canLoadPreviousPage (state) {
      return false
    },
    // fake the current page #
    // TODO: everything is setup around infinite scroll, for regular pagination refactoring is needed
    currentPage (state, getters) {
      return Math.ceil(state.pagination.offset / state.pagination.limit)
    },
    filteredCount (state, getters, rootState, rootGetters) {
      return config.items.counts.filtered(state, getters, rootState, rootGetters)
    },
    // true if any kind of operation is active
    loading (state) {
      return Object.keys(state.loadingIndicators).some(k => !!state.loadingIndicators[k])
    },
    totalCount (state, getters, rootState, rootGetters) {
      return config.items.counts.total(state, getters, rootState, rootGetters)
    }
  }
}
